import { render } from "./TokenCard.vue?vue&type=template&id=b6369b8e&scoped=true"
import script from "./TokenCard.vue?vue&type=script&lang=js"
export * from "./TokenCard.vue?vue&type=script&lang=js"

import "./TokenCard.vue?vue&type=style&index=0&id=b6369b8e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b6369b8e"]])

export default __exports__